export default "__VITE_PUBLIC_ASSET__b9fa1435__"